module.exports = __webpack_public_path__ + "static/img/fengmi.1e924080.png";